/**
 * @generated SignedSource<<229566b26c144eec05bf4849487c7f60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutinesListItemContent_routine$data = {
  readonly description: string | null;
  readonly descriptionFiles: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ListItemDescriptionContentFiles_files">;
  }>;
  readonly descriptionImages: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ListItemDescriptionContent_images">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WorkspaceRoutinesListItemContent_routine";
};
export type WorkspaceRoutinesListItemContent_routine$key = {
  readonly " $data"?: WorkspaceRoutinesListItemContent_routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemContent_routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutinesListItemContent_routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListItemDescriptionContent_images"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListItemDescriptionContentFiles_files"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "aa31b05812a987303fbb1554746480c5";

export default node;
